<template>
  <span v-if="format == 'chips'">
    <v-chip
      v-for="(item,item_index) in formatedDates"
      :key="item_index"
      small
      color="grey lighten"
      text-color="white"
    >{{ item }}</v-chip>
  </span>
  <div v-else-if="format == 'list'" v-html="htmlRows"></div>
</template>

<i18n>
{
  "de" : {
    "today_text" : "heute"
  },
  "en" : {
    "today_text" : "today"
  }
}
</i18n>
<script>
// Mixins
import { formatDates } from "@/components/mixins/FormattingMixin";

export default {
  props: {
    items: {
      type: [Array, String],
      default: () => []
    },
    format: {
      type: String,
      default: "list"
    }
  },
  computed: {
    formatedDates() {
      return formatDates(this.items, this.$t("today_text"));
    },
    htmlRows() {
      return this.formatedDates.join("<br />");
    }
  }
};
</script>
